import React, { useState, useEffect } from 'react'
import axios from 'axios'

import loadPdf from '../../assets/loadPdf.gif'

const mediaWeb = window.matchMedia("(min-width:600px)").matches
const converterData = (data) => {
    const [ano, mes, dia] = data.split("-")
    const dataFormatada = `${dia}/${mes}/${ano}`
    return dataFormatada
}

const Processo = () => {
    const id = window.location.pathname.slice(19)
    const [processo, setProcesso] = useState({})
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        axios.post('/api/juridico/getProcesso', { id: id })
            .then(res => setProcesso(res.data))
            .catch(error => alert(error.response.message))
    }, [id])

    const deleteDocumento = (documentoId, documentoNome) => {
        if (window.confirm(`Tem certeza de que deseja excluir o documento "${documentoNome}"?`)) {
            axios.delete(`/api/juridico/deleteDocumento/${documentoId}`)
                .then(() => {
                    alert(`Documento "${documentoNome}" excluído com sucesso!`)
                    window.location.reload()
                })
                .catch(error => {
                    alert(`Erro ao excluir o documento: ${error.response?.data?.message || error.message}`)
                })
        }
    }

    const handlePrintProcess = async () => {
        try {
            setLoading(true)
            const response = await axios.get(`/api/juridico/imprimirProcesso/${processo._id}`, {
                responseType: 'blob'
            })
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'processo_merged.pdf')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        } catch (error) {
            console.error('Erro ao imprimir o processo:', error)
            alert('Erro ao imprimir o processo. Tente novamente.')
        } finally {
            setLoading(false)
        }
    }

    const assinarPortaria = (idPortaria, idProcesso) => {
        axios.post('/api/juridico/assinarPortaria', { idPortaria: idPortaria, idProcesso: idProcesso })
            .then(res => {
                alert(res.data)
                window.location.reload()
            })
            .catch(error => {
                alert(error.response.data.message)
            })
    }
    
    return (
        <>
            <h5 style={{ textAlign: "left", margin: "5vh 0 5vh 2vw", color: "#036666" }}>
                Processo: {processo.numero ? `${processo.numero}/${processo.dataCriacao.slice(0, 4)}` : ""}
            </h5>
            <div style={{ position: mediaWeb ? "relative" : null, overflowX: mediaWeb ? null : "auto" }}>
                <table className='tableJuridico' style={{ width: mediaWeb ? null : "150vw" }}>
                    <thead>
                        <tr>
                            <th className='thJuridico'>DOCUMENTO</th>
                            <th className='thJuridico'>DATA</th>
                            <th className='thJuridico'>NÚMERO</th>
                            <th className='thJuridico' style={{ width: "15vw" }}></th>
                            <th className='thJuridico' style={{ width: "15vw" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {processo._id ? (
                            processo.documentos.map((el, index) => (
                                <tr key={index}>
                                    <td className='tdJuridico'>{el.tipo === "anexo" ? el.documento : "Despacho"}</td>
                                    <td className='tdJuridico'>{converterData(el.createdAt.slice(0, 10))} {el.createdAt.slice(11, 19)}</td>
                                    <td className='tdJuridico'>{el.numeroAnexo.slice(-4)}/{el.createdAt.slice(0, 4)}</td>
                                    <td className='tdJuridico' style={{ textAlign: "center" }}>
                                        <button className="botaoNPed"
                                            onClick={() => window.open(el.tipo === "anexo" ? el.url : `/juridico/despachoView/${el.id}`, '_blank')}
                                            style={{ width: mediaWeb ? null : "20vw" }}>Abrir</button>
                                    </td>
                                    <td className='tdJuridico' style={{ textAlign: "center" }}>
                                        {el.tipo === "anexo" && el.tipoAnexo !== "Capa do Processo" ? (
                                            <button className="botaoNPed"
                                                onClick={() => deleteDocumento(el.id, el.documento)}
                                                style={{ width: mediaWeb ? null : "20vw", backgroundColor: "red" }}>Excluir</button>
                                        ) : (<></>)}
                                        {el.tipoAnexo === "Portaria" && el.assinaturaPortaria === false &&
                                            localStorage.matriculaJ === "carlos.francisco" ? (
                                            <button className="botaoNPed"
                                                onClick={() => assinarPortaria(el.id, processo._id)}
                                                style={{ width: mediaWeb ? null : "20vw" }}>Assinar</button>
                                        ) : (<></>)}
                                    </td>
                                </tr>
                            ))
                        ) : (<></>)}
                    </tbody>
                </table>
                <button className="botaoNPed" onClick={() => window.location = `/juridico/novoAnexo/${processo._id}`}
                    style={{ width: mediaWeb ? null : "20vw" }}>Anexo</button>
                <button className="botaoNPed" onClick={() => window.location = `/juridico/novoDespacho/${processo._id}`}
                    style={{ width: mediaWeb ? null : "20vw", marginLeft: "2vw" }}>Despacho</button>
                <button className="botaoNPed" onClick={handlePrintProcess}
                    style={{ width: mediaWeb ? null : "20vw", marginLeft: "2vw" }}>
                    Imprimir
                </button>
            </div>

            {loading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    zIndex: 9999
                }}>
                    <img src={loadPdf} alt="Carregando PDF" style={{ width: '150px', height: '150px' }} />
                </div>
            )}
        </>
    )
}

export default Processo
